import mixpanel from "mixpanel-browser";

interface MixpanelStub {
  track: (...args: unknown[]) => void;
  identify: (...args: unknown[]) => void;
  alias: (...args: unknown[]) => void;
  people: { set: (...args: unknown[]) => void };
  reset: () => void;
}

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const token = config.public.mixpanelToken as string | undefined;
  const enabled = config.public.appEnv === "production";

  if (!import.meta.client || !enabled || !token) {
    const stub: MixpanelStub = {
      track: () => {},
      identify: () => {},
      alias: () => {},
      people: { set: () => {} },
      reset: () => {},
    };
    return { provide: { mixpanel: stub } };
  }

  mixpanel.init(token, {
    // Route ingestion to Mixpanel's EU servers. The SDK defaults to the US
    // host (api-js.mixpanel.com); EU data forwarding from the US endpoints
    // ends July 2026, after which US-pointed events are dropped.
    api_host: "https://api-eu.mixpanel.com",
    debug: !enabled,
    track_pageview: false,
    persistence: "localStorage",
    ignore_dnt: true,
  });

  return { provide: { mixpanel } };
});
